module.exports = __webpack_public_path__ + "img/about_L.5e4c093e.svg";